import React from 'react';
import { withTranslation } from 'react-i18next';
import { GTM_PHYSICAL_CARD_CTA_CLICK } from '../../../constants/defaults';

const ButtonSection = props => {
  const isBrowser = typeof window !== 'undefined';
  const userAgent = isBrowser ? navigator.userAgent : '';
  const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
  const isDesktop = isBrowser && !isMobile;
  const {
    classes,
    showMedia,
    t,
    i18n,
    openModal,
    triggerGTMEvents,
    closeMobileButtonModal
  } = props;

  return (
    <div className="send-button-section">
      <div className={`btn-wrapper ${isDesktop ? 'desktopBtnWrapper' : ''}`}>
        <div className="btn-padding">
          <button
            disabled={showMedia !== '' && showMedia === 'Email'}
            className={`${
              classes.button
            } email-button email-send email-button-padding themeFocus dialogComponent mobileDialog ${
              props.activeButton && 'active'
            }`}
            onMouseDown={e => e.preventDefault()}
            onClick={props.toggleShow.bind(this, 'Email')}
            aria-disabled="false"
            aria-label={t('Email discount card')}
          >
            {t('Email')}
          </button>
        </div>
        <div className="btn-padding">
          <button
            disabled={showMedia !== '' && showMedia === 'Text'}
            className={`${
              classes?.button
            } text-button text-send text-button-padding themeFocus dialogComponent mobileDialog ${
              props.activeButton && 'active'
            }`}
            onMouseDown={e => e.preventDefault()}
            onClick={props.toggleShow.bind(this, 'Text')}
            aria-disabled="false"
            aria-label={t('Text discount card')}
          >
            {t('Text')}
          </button>
        </div>
        <div className="btn-padding physicalCardButton">
          <button
            className={`${
              classes?.button
            } getCardButton pdf-send print-button-padding themeFocus mobileDialog ${
              props.activeButton && 'active'
            }`}
            onClick={() => {
              if (closeMobileButtonModal) {
                closeMobileButtonModal();
              }
              openModal();
              triggerGTMEvents(GTM_PHYSICAL_CARD_CTA_CLICK);
            }}
            aria-disabled="false"
            aria-label={t('Get physical discount card')}
          >
            <span>{t('Get physical card')}</span>
          </button>
        </div>
        {i18n.language === 'en' && isDesktop && (
          <div className="btn-padding">
            {props.pdfLoading ? (
              <div className="loaderPdf">
                <img
                  src="/content/images/loader/loading.gif"
                  alt="loader"
                  className="pdfLoader"
                  role="progressbar"
                />
              </div>
            ) : (
              <button
                onClick={props.printAsPDF.bind(this)}
                className={`${
                  classes.button
                } pdf-button pdf-send print-button-padding themeFocus dialogComponent mobileDialog ${
                  props.activeButton && 'active'
                }`}
                aria-disabled="false"
                aria-label={t('Print discount card')}
              >
                <span className="pdf-button">Print</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default withTranslation()(ButtonSection);
